import classNames from 'classnames';
import React, { useState, useMemo } from 'react';
import { useModal } from 'react-modal-hook';
import {
	ProductsLayoutTypesBold,
	ProductsLayoutTypesClassic,
	ProductsLayoutTypesFun,
	TemplateClassNames,
} from '../../../../../types/template-layouts';
import { PageModule, Product } from "../../../../../types/working-model";
import { getStylingOverrides } from "../../../utils";
import ProductItem from './product-item';
import '../../../modules/products/products.scss';
import './products.scss';
import { TypographyItem } from '../../../../general-ui/typography-item/typography-item';
import { ProductDetailsModal } from '../../../containers/product-details-modal/product-details.modal';
import { ETabLayoutClassNames } from '../../session';
import { useParams } from 'react-router';
import { ParamsProps } from '../../../live-event';
import { getTextValue } from '../../../../../utils/utils';

interface ProductsProps {
	module: PageModule;
	template: TemplateClassNames;
	tabLayout: ETabLayoutClassNames;
}
const SessionProducts: React.FC<ProductsProps> = ({ module, template, tabLayout }) => {
	const [product, setProduct] = useState<Product>();
	const params: ParamsProps = useParams();
	const language = params.language || 'en';
	const { content, styling_overrides, modules } = module;
	const stylingOverrides = getStylingOverrides(styling_overrides);
	const {
		backgroundColor,
		backgroundImg,
		customHeadingOverrides,
	} = stylingOverrides;

	const { custom_heading } = getTextValue(content, language);

	const layout = useMemo(() => {
		if (template) {
			switch (template) {
				case TemplateClassNames.Apollo: return ProductsLayoutTypesClassic.standard;
				case TemplateClassNames['Studio 54']: return ProductsLayoutTypesBold.grid;
				case TemplateClassNames.O2: return ProductsLayoutTypesFun.vertical_list;
				default: return "standard";
			}
		}
	}, [template]);

	const [showProductDetailsModal, hideProductDetailsModal] = useModal(
		() => (
			<ProductDetailsModal
				template={template}
				layout_type={layout}
				onClose={hideProductDetailsModal}
				product={product as Product}
				stylingOverrides={stylingOverrides}
				language={language}
			/>
		),
		[product, template, layout, language]
	);

	if (!module.modules) return null;
	return (
		<section
			className={classNames(
				'session-module products',
				`products-${layout}`,
				`products-${tabLayout}-tabs`,
				template,
				backgroundColor
			)}
			style={backgroundImg}
		>
			<div>
				<header>
					<TypographyItem className={classNames('evt-caption-1 products-custom-heading', customHeadingOverrides)} tagName="p">
						{custom_heading}
					</TypographyItem>
				</header>
				<ul className="product-list">
					{modules?.map((module: Product) => (
						<ProductItem
							key={module.product}
							module={module}
							stylingOverrides={stylingOverrides}
							template={template}
							onClick={(product) => {
								setProduct(product);

								showProductDetailsModal();
							}}
						/>
					))}
				</ul>
			</div>
		</section>
	);


};

export default SessionProducts;